import * as React from 'react';
import './FlowLayout.less';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import FlowProgressBar from '../common/FlowProgressBar';
import logoPng from '../../images/logo.png';
import { hasValue } from '../../lib/utils';

const FlowLayout = (props: FlowLayoutProps) => {
	const { title, children, currentFlowProgressBarName, flowProgressBarNames, workflowServiceName } = props;
	if (!children) return null;

	const hasProgressBar = shouldShowProgressBar(currentFlowProgressBarName, flowProgressBarNames);

	return (
		<div className="flowLayout">
			<div className={classNames('dataCaptureHeading', !hasProgressBar ? 'noProgressBar' : '')}>
				<img className="logo" src={logoPng} height={56} alt="logo" />
				{workflowServiceName && (
					<div className="workflowServiceName">
						<span>
							{hasValue(props.country)
								? workflowServiceName.replace('International', props.country)
								: workflowServiceName}
						</span>
					</div>
				)}
				{hasProgressBar && (
					<FlowProgressBar
						navigateToPage={props.navigateToPage}
						showFlowProgressBarLine={props.showFlowProgressBarLine}
						currentFlowProgressBarName={currentFlowProgressBarName}
						flowProgressBarNames={flowProgressBarNames}
					/>
				)}
				<Helmet>
					<title>{title}</title>
				</Helmet>
			</div>
			{children}
		</div>
	);
};

export interface FlowLayoutProps {
	title: string;
	navigateToPage?: (flowProgressBarName: string) => void;
	flowProgressBarNames?: string[];
	showFlowProgressBarLine?: boolean;
	currentFlowProgressBarName?: string;
	children?: React.ReactNode;
	workflowServiceName?: string;
	country?: string;
}

FlowLayout.defaultProps = {
	flowProgressBarNames: null,
	showFlowProgressBarLine: true,
	currentFlowProgressBarName: null,
	children: null,
	workflowServiceName: null,
	navigateToPage: null
};

export default FlowLayout;

const shouldShowProgressBar = (currentFlowProgressBarName: string, flowProgressBarNames: string[]) => {
	if (!hasValue(flowProgressBarNames)) return false;
	return flowProgressBarNames.includes(currentFlowProgressBarName);
};
